



















import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo, share } from './api';
import BottomTabbar from '@/components/BottomTabbar.vue';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  baseInfo: any = {};
  option = config.OPTHINES;
  async created() {
    const ret = await getBaseInfo();
    console.log('base info is:', ret);
    if ((ret as any).code === 200) {
      this.baseInfo = ret.data;
    }
    share(this);
    this.$addPv(this.baseInfo.activityId);
  }
}
